import common from './common.json';
import createEvent from './create-event.json';
import eventSteps from './event-steps.json';
import events from './events.json';

export default {
  common,
  createEvent,
  eventSteps,
  events,
};
